'use client'
import { useIndustriesNavbarScroll } from '@/Hooks'
import React from 'react'
import IndHeroSection from './components/IndHeroSection'
import IndSectionTwo from './components/IndSectionTwo'
import GamingSectionThree from './components/GamingSectionThree'
import GamingFromStrategy from './components/GamingFromStrategy'
import Supercharge from './components/Supercharge'
import AdvancedFeatures from './components/AdvancedFeatures'
import GameWhyChoose from './components/GameWhyChoose'
import {
   ContactUsForm,
   FAQs,
   GameChangingIdea,
   WordsOfAppreciation,
} from '@/components'

const faqData = [
   {
      question: 'What is gaming and sports software development?',
      answer:
         'Game development for sports and games entails designing software solutions for video games, sports gaming platforms, fantasy sport applications, and sporting management software. The solutions apply AI, blockchain, cloud gaming, and IoT to facilitate improvements in gameplay, analytics, and user interactions.',
   },
   {
      question: 'How can gaming software benefit my business?',
      answer:
         'Game software can lead to user participation, generate revenues through in-game ads and micro-transactions, improve multiplayer experiences, and offer AI-based insights for improved decision-making. It also facilitates painless esports tournament management and fantasy sports league automation.',
   },
   {
      question:
         'What technologies do you use for game and sports software development?',
      answer:
         'IoT for real-time sports tracking, cloud gaming for lag-free experiences, blockchain for safe transactions and NFTs, AI-powered analytics, and AR/VR for engaging gameplay are some of the cutting-edge technology we use.',
   },
   {
      question: 'Do you provide custom game development services?',
      answer:
         'Yes, we have custom game development services, ranging from mobile and PC game development, multiplayer platforms, esports solutions, and fantasy sports software. Our offerings consist of real-time match tracking, leaderboard integration, and AI-powered game mechanics.',
   },
   {
      question: 'Can you integrate blockchain and NFTs into gaming platforms?',
      answer:
         'Certainly! We build blockchain gaming platforms with smart contracts, NFT assets, and tokenized in-game economies. Our solutions facilitate play-to-earn models, secure transactions, and transparent trading of assets.',
   },
   {
      question: 'How does AI improve gaming and sports software?',
      answer:
         'AI improves game experiences through real-time player analysis, AI-balanced opponents, automated match forecasting, and personalized game recommendations. AI helps sports software with strategy maximization, injury prevention, and performance monitoring.',
   },
   {
      question: 'Do you develop esports and fantasy sports platforms?',
      answer:
         'Yes, we create fantasy sports and esports platforms with live match tracking, automated scoring, tournament administration, and social engagement functionality. Through our solutions users can stream games live while placing bets directly from the application coupled with AI analysis of the games.',
   },
   {
      question: 'What are the key features of a fantasy sports app?',
      answer:
         'Our fantasy sports apps feature live scores during matches, player drafting, artificial intelligence team suggestions, social media platforms, push notifications, GPS location, and straightforward payment gateways.',
   },
   {
      question: 'How do cloud gaming solutions enhance gaming performance?',
      answer:
         'Cloud gaming solutions support high-end games to be executed on any device without downloads. They provide low-latency streaming, scalable architecture, real-time synchronization, and adaptive resolution for a smooth game.',
   },
   {
      question:
         'Why choose Benzatine for gaming and sports software development?',
      answer:
         'Benzatine provides tailored, scalable, and secure gaming and sports software solutions powered by AI, blockchain, and cloud. We deliver end-to-end development, real-time insights, multiplayer integration, and 24/7 support for long-term success.',
   },
]; 

function GamingAndSportsPage() {
   useIndustriesNavbarScroll()
   return (
      <>
         <IndHeroSection />
         <IndSectionTwo />
         <GamingSectionThree />
         <GamingFromStrategy />
         <Supercharge />
         <AdvancedFeatures />
         <GameWhyChoose />
         <GameChangingIdea />
         <section className="section appreciation-slider-section page_top_section section_secondary_bg">
            <WordsOfAppreciation />
         </section>
         <FAQs faqsConst={faqData} />
         <ContactUsForm />
      </>
   )
}

export default GamingAndSportsPage
